// src/home/Chatbot/chat.constants.js
export const chatConstants = {
  // Fired when the user initiates a send
  SEND_MESSAGE_REQUEST: "CHAT_SEND_MESSAGE_REQUEST",

  // Fired when FastAPI returns successfully
  SEND_MESSAGE_SUCCESS: "CHAT_SEND_MESSAGE_SUCCESS",

  // Fired when the request fails (network/server error)
  SEND_MESSAGE_FAILURE: "CHAT_SEND_MESSAGE_FAILURE",

  // Optional: Clear chat history
  CLEAR_CHAT: "CHAT_CLEAR_CHAT",
};
